import jsf from 'json-schema-faker';
import { Validator } from 'jsonschema';
import { useSelector } from "react-redux";
import { useSetWidgetAttribute } from "./useSetWidgetAttribute.js";
import { useCallback, useEffect } from "react";
import { createDefaults } from '../../../helpers/schema.js';
import { columnSchema, GRID_SCHEMAS } from '../gen2_widgets/grid/gridSchemas.js';

jsf.option({
  useDefaultValue: true,
  fillProperties: false,
  alwaysFakeOptionals: true,
});

export const useGridWidgetSettings = (widgetId) => {
  const setAttribute = useSetWidgetAttribute(widgetId);
  const columns = useSelector(s => s.dashboard.widgets[widgetId].settings.columns || []);
  const validator = new Validator();

  useEffect(() => {
    GRID_SCHEMAS.forEach(s => validator.addSchema(s, s.id || s.$id));
  }, []);

  const addColumn = useCallback(() => {
    const newColumns = [
      ...columns,
      {...getDefaultColumn()}
    ];
    setAttribute('settings.columns', newColumns);
  }, [columns]);

  const moveColumn = useCallback((dragIndex, hoverIndex) => {
    const newColumns = [...columns]
    const [moved] = newColumns.splice(dragIndex, 1)
    newColumns.splice(hoverIndex, 0, moved)
    setAttribute('settings.columns', newColumns)
  }, [columns]);

  const removeColumn = useCallback((id) => {
    if (window.confirm(I18n.t('delete_column_confirmation'))){
      const newColumns = columns.filter((s) => s.id !== id);
      setAttribute('settings.columns', newColumns);
    }
  }, [columns]);

  /**
   * Get default settings based on json schema.
   */
  const getDefaultColumn = useCallback(() => {
    const props = createDefaults(columnSchema || {}, GRID_SCHEMAS);
    return {
      ...props,
      id: Math.random().toString(36).substring(7)
    }
  }, []);

  return {
    addColumn,
    moveColumn,
    removeColumn
  }
}